module.exports = __webpack_public_path__ + "static/media/mp-military-promotion.036b8fc9.png";